'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "orientation", "type"];
import PropTypes from 'prop-types';
import devLogger from 'react-utils/devLogger';
import UIDeviceFrameDesktop from './UIDeviceFrameDesktop';
import UIDeviceFrameTablet from './UIDeviceFrameTablet';
import UIDeviceFrameMobile from './UIDeviceFrameMobile';
import { jsx as _jsx } from "react/jsx-runtime";
const DEVICE_TYPES = {
  desktop: UIDeviceFrameDesktop,
  tablet: UIDeviceFrameTablet,
  mobile: UIDeviceFrameMobile
};
export default function UIDeviceFrame(props) {
  const {
      height,
      orientation,
      type
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const DeviceFrame = DEVICE_TYPES[type];
  if (process.env.NODE_ENV !== 'production') {
    if (type === 'desktop' && orientation === 'landscape') {
      devLogger.warn({
        message: `UIDeviceFrame: There is no designed state for a landscape desktop device frame.
            Change either the \`type\` or the \`orientation\``,
        key: 'UIDeviceFrame: landscape desktop'
      });
    }
    if (height && type !== 'desktop') {
      devLogger.warn({
        message: `UIDeviceFrame: Only the desktop device frame applies the height prop.`,
        key: 'UIDeviceFrame: height only applies to desktop'
      });
    }
  }
  return /*#__PURE__*/_jsx(DeviceFrame, Object.assign({}, rest, {
    height: height,
    orientation: orientation
  }));
}
UIDeviceFrame.propTypes = {
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  type: PropTypes.oneOf(Object.keys(DEVICE_TYPES))
};
UIDeviceFrame.defaultProps = {
  orientation: 'portrait',
  type: 'desktop'
};
UIDeviceFrame.displayName = 'UIDeviceFrame';